import { Card, RegisterForm } from "../components";
import { usePageTitle } from "../hooks";

/**
 * RegisterPage - Parent registration page with Supabase Auth integration.
 */
export function RegisterPage() {
  usePageTitle("Create Account");

  return (
    <div className="flex flex-col items-center justify-center flex-1 px-4 py-8">
      <Card variant="elevated" className="w-full max-w-md p-8">
        <h1 className="font-display font-bold text-display-sm text-magic-600 text-center mb-2">
          Start Your Adventure!
        </h1>
        <p className="font-body text-body-md text-neutral-600 text-center mb-8">
          Create a free account for your child
        </p>

        <RegisterForm />
      </Card>
    </div>
  );
}

export default RegisterPage;
